import classNames from 'classnames';
import React, { useContext } from 'react';

import { Anchor } from '@zooplus/ui-components';

import AppContext from '../../context';
import { UiCategory } from '../../types';
import {
    convertTrackingIdTitle,
    getTrackingId,
    isSpecialLink,
} from '../../utils/categoryUtils';
import { LinkTypeEnum } from '../Link/Link';

import styles from './CategoryFlyout.module.scss';
import { ExpandableCategoryList } from './ExpandableCategoryLinks';

export function AnimalFlyoutV2({ category }: { category: UiCategory }) {
    const { translations } = useContext(AppContext);
    const viewAllLabel = translations.get('shop.header.categories.title.link');

    const { children = [], specials = [], title, path } = category;
    const categories = [...children, ...specials];

    const categoryTrackingId = 'animal';
    const trackingIdTitle = convertTrackingIdTitle(title);
    return (
        <div
            className={classNames(styles.animalflyout, styles.scrollBox)}
            data-zta={`category-flyout-v2-${categoryTrackingId}-${trackingIdTitle}`}>
            <div className={styles.flyOutHeader}>
                <Anchor
                    href={path}
                    data-link-type={LinkTypeEnum.PRIMARY}
                    data-zta={`category-flyout-${trackingIdTitle}-level2-link`}>
                    {viewAllLabel} {title}
                </Anchor>
            </div>
            <div className={styles.animalPanelV2}>
                {categories.map((categoryL3) => {
                    const {
                        children: l3Children = [],
                        specials: l3Specials = [],
                    } = categoryL3;
                    const childCategories = [...l3Children, ...l3Specials];
                    const hasChildren = childCategories.length > 0;
                    const isSpecial = isSpecialLink(categoryL3);
                    return (
                        <ul
                            id={getTrackingId({
                                parentTitle: title,
                                type: categoryL3.type,
                                level: categoryL3.level,
                                index: children.findIndex(
                                    (item) => item.extId === categoryL3.extId,
                                ),
                                title: categoryL3.title,
                            })}
                            className={styles.animalPanelGroup}
                            key={categoryL3.path}>
                            <li className={styles.groupHeader}>
                                <Anchor
                                    variant={
                                        isSpecial
                                            ? 'danger'
                                            : LinkTypeEnum.NEUTRAL
                                    }
                                    data-link-type={
                                        isSpecial
                                            ? LinkTypeEnum.OFFER
                                            : LinkTypeEnum.NEUTRAL
                                    }
                                    className={classNames({
                                        [styles.nonBoldSpecialsText]:
                                            isSpecial && !hasChildren,
                                    })}
                                    data-zta="category-flyout-animal-group-header"
                                    aria-label="group-header"
                                    href={categoryL3.path}>
                                    {categoryL3.title}
                                </Anchor>
                            </li>
                            {hasChildren && (
                                <ExpandableCategoryList
                                    categories={childCategories}
                                />
                            )}
                        </ul>
                    );
                })}
            </div>
        </div>
    );
}
